import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  readonly navigationPending = signal(false);

  private readonly router = inject(Router);
  private hideProgressTimer: ReturnType<typeof globalThis.setTimeout> | undefined;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.clearHideProgressTimer();
        this.navigationPending.set(true);
        return;
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.hideProgressTimer = globalThis.setTimeout(() => {
          this.navigationPending.set(false);
          this.hideProgressTimer = undefined;
        }, 120);
      }
    });
  }

  private clearHideProgressTimer(): void {
    if (this.hideProgressTimer === undefined) {
      return;
    }

    globalThis.clearTimeout(this.hideProgressTimer);
    this.hideProgressTimer = undefined;
  }
}
